import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withGetScreen } from 'react-getscreen'
import FAQsDesktop from './FAQsDesktop'
import FAQsMobile from './FAQsMobile'

class FAQs extends Component {
  render() {
    if (this.props.isMobile()) {
      return <FAQsMobile />;
    } else {
      return <FAQsDesktop />;
    }
  }
}

const options = { mobileLimit: 900, shouldListenOnResize: true  }
export default connect()(withGetScreen(FAQs, options))
